import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M12 15a4 4 0 004-4V6a4 4 0 10-8 0v5a4 4 0 004 4zm-2-9a2 2 0 114 0v5a2 2 0 11-4 0V6z" }), /* @__PURE__ */ _jsx("path", { d: "M19 11a1 1 0 00-2 0 5 5 0 01-10 0 1 1 0 00-2 0 7 7 0 006 6.92V20H8.89a.89.89 0 00-.89.89v.22c0 .492.398.89.89.89h6.22a.89.89 0 00.89-.89v-.22a.89.89 0 00-.89-.89H13v-2.08A7 7 0 0019 11z" })]
		})
	})
});
export { SvgMicOn as ReactComponent };
